import { render, staticRenderFns } from "./Afp.vue?vue&type=template&id=c9c84216"
import script from "./Afp.vue?vue&type=script&lang=js"
export * from "./Afp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports